import { render, staticRenderFns } from "./DebtFilter.vue?vue&type=template&id=0afa908c&"
import script from "./DebtFilter.vue?vue&type=script&lang=js&"
export * from "./DebtFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports